module.exports = __webpack_public_path__ + "img/enterprise-main12.7e59470e.png";